import {observer} from 'mobx-react';
import {RouteComponentProps} from 'react-router';
import {useStore} from '../../hooks/use-store';
import React, {memo, useContext, useEffect} from 'react';
import {CustomerServiceDashboard} from './CustomerServiceDashboard';
import {CustomerServiceDashboardProvider} from '../context';
import {PrivateRoute} from 'Mri.Web.Common';
import {CustomerServiceAdmin} from './CustomerServiceAdmin';

export interface IAccountsViewProps extends RouteComponentProps<undefined> {
}

export const CustomerServiceDashboardView = memo((props: IAccountsViewProps) => {
    const {accountStore} = useStore();
    useEffect(() => {
        // console.log('CustomerServiceDashboardView useEffect');
    }, []);

    return (
        <>
            {/*<CustomerServiceDashboardProvider>*/}
                <PrivateRoute
                    path="/customer-service-dashboard/admin"
                    exact
                    component={CustomerServiceAdmin}
                    roles={['MriAdmin', 'MriCustomerServiceAdmin']}
                    user={accountStore.user}
                />
                <PrivateRoute
                    path="/customer-service-dashboard"
                    exact
                    component={CustomerServiceDashboard}
                    roles={['MriAdmin', 'MriCustomerServiceAdmin', 'MriCustomerServiceRep']}
                    user={accountStore.user}
                />
            {/*</CustomerServiceDashboardProvider>*/}
        </>
    );
});

export default CustomerServiceDashboardView;
